import { object } from "prop-types"
import Icon from "components/planning_center_icon"

const TableColumnIcon = (row, _col) => {
  let iconSymbol = "general#bill"

  if (row.type === "Refund") {
    iconSymbol = "registrations#refund"
  } else if (row.type === "Check" || row.instrument === "Check") {
    iconSymbol = "church-center#bank-check"
  } else if (row.instrument === "Credit Card") {
    iconSymbol = "general#credit-card"
  }

  return (
    <>
      <span className="font-size-2">
        <Icon symbol={iconSymbol} />
      </span>
      <span className="text-label--hide">{row.type}</span>
    </>
  )
}

TableColumnIcon.propTypes = {
  row: object.isRequired,
  col: object
}

export default TableColumnIcon
